export default __webpack_public_path__ + "app/components/tables/intradayEntries/reactIntradayEntriesTable.html";